var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-bmap',{staticClass:"bmap-demo",attrs:{"vid":"landlayout","zoom":_vm.zoom,"center":_vm.center,"events":_vm.events}})
}
var staticRenderFns = []

export { render, staticRenderFns }